import { Component, OnInit } from '@angular/core';
import { AlertMessages } from '../../core/AlertMessages';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.css']
})
export class AlertMessageComponent implements OnInit {
removeCss: boolean = false;

  public classref = AlertMessages;

  constructor() { }

  ngOnInit() {

  }

  ClearAlerts() {
    AlertMessages.ClearAlerts();
  }

  RemoveAlert(AlertId){
    AlertMessages.RemoveAlert(AlertId);
  }

}
